module.exports = __webpack_public_path__ + "img/azerbaijan.40e8217f.svg";